var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "myExamGrades" },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("div", { staticClass: "information" }, [
              _c("div", { staticClass: "informationCenter" }, [
                _c(
                  "div",
                  { staticClass: "informationTitle" },
                  [_c("Title", { attrs: { text: "我的成绩" } })],
                  1
                ),
                _c("div", { staticClass: "elTabs" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        "margin-bottom": "10px",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.scorePrintingClick },
                        },
                        [_vm._v("打印")]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "averageScoreClass" }, [
                    _vm._v("必修课平均分: "),
                    _c("span", [_vm._v(_vm._s(_vm.printInfo.avg_score))]),
                  ]),
                  _c("div", { staticClass: "informationDiv" }, [
                    _c(
                      "div",
                      {
                        ref: "print-content",
                        staticClass: "scorePrintingAE-print-box",
                      },
                      [
                        _vm.isPrint
                          ? _c("div", [
                              _c("div", { staticClass: "title" }, [
                                _vm._v("重庆医科大学学业成绩表"),
                              ]),
                              _c(
                                "div",
                                { staticClass: "floor-text floor-text1" },
                                [
                                  _c("p", { staticClass: "text" }, [
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v("学       号："),
                                    ]),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(_vm.printInfo.student_code)
                                      ),
                                    ]),
                                  ]),
                                  _c("p", { staticClass: "text" }, [
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v("姓       名："),
                                    ]),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(_vm.printInfo.student_title)
                                      ),
                                    ]),
                                  ]),
                                  _c("p", { staticClass: "text" }, [
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v("学       制："),
                                    ]),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(_vm._s(_vm.printInfo.year)),
                                    ]),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "floor-text floor-text1" },
                                [
                                  _c("p", { staticClass: "text" }, [
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v("院       系："),
                                    ]),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(_vm.printInfo.college_title)
                                      ),
                                    ]),
                                  ]),
                                  _c("p", { staticClass: "text" }, [
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v("专业名称："),
                                    ]),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(_vm._s(_vm.printInfo.pro_title)),
                                    ]),
                                  ]),
                                  _c("p", { staticClass: "text class" }, [
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v("班级名称："),
                                    ]),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(_vm._s(_vm.printInfo.class_title)),
                                    ]),
                                  ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "table-box" }, [
                          _c(
                            "table",
                            { staticClass: "table" },
                            [
                              _c("tbody", [
                                _c("tr", [
                                  _c("th", [_vm._v("课程名称")]),
                                  _c("th", { staticStyle: { width: "8%" } }, [
                                    _vm._v("性质"),
                                  ]),
                                  _c("th", { staticStyle: { width: "10%" } }, [
                                    _vm._v("学分"),
                                  ]),
                                  _c("th", { staticStyle: { width: "15%" } }, [
                                    _vm._v("正考总评"),
                                  ]),
                                  _c("th", { staticStyle: { width: "15%" } }, [
                                    _vm._v("补考总评"),
                                  ]),
                                  _c("th", { staticStyle: { width: "10%" } }, [
                                    _vm._v("最终成绩"),
                                  ]),
                                  _c("th", { staticStyle: { width: "20%" } }, [
                                    _vm._v("备注"),
                                  ]),
                                ]),
                              ]),
                              _vm._l(_vm.parinScoreList, function (item, key) {
                                return _c(
                                  "tbody",
                                  { key: key },
                                  [
                                    _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "left",
                                          attrs: { colspan: "7" },
                                        },
                                        [_vm._v(_vm._s(_vm.yearHandle(key)))]
                                      ),
                                    ]),
                                    _vm._l(item, function (item2, index2) {
                                      return _c("tr", { key: index2 }, [
                                        _c("td", { staticClass: "left" }, [
                                          _vm._v(_vm._s(item2.course_title)),
                                        ]),
                                        _c("td", [_vm._v("必修")]),
                                        _c("td", [
                                          _vm._v(_vm._s(item2.credits)),
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              item2.are_score == "-1.00"
                                                ? ""
                                                : item2.are_score
                                            )
                                          ),
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              item2.resit_score == "-1.00"
                                                ? ""
                                                : item2.resit_score
                                            )
                                          ),
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              item2.score == "-1.00"
                                                ? ""
                                                : item2.score
                                            )
                                          ),
                                        ]),
                                        _c("td", [
                                          _vm._v(_vm._s(item2.remark)),
                                        ]),
                                      ])
                                    }),
                                  ],
                                  2
                                )
                              }),
                              _c("tbody"),
                            ],
                            2
                          ),
                        ]),
                        _vm.isPrint
                          ? _c("div", { staticClass: "bot" }, [
                              _c("p", { staticClass: "text" }, [
                                _c("span", { staticClass: "name" }, [
                                  _vm._v("必修课平均分："),
                                ]),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.printInfo.avg_score)),
                                ]),
                              ]),
                              _c("p", { staticClass: "text" }, [
                                _c("span", { staticClass: "value" }, [
                                  _vm._v("重庆医科大学继续教育学院"),
                                ]),
                              ]),
                              _c("p", { staticClass: "text" }, [
                                _c("span", { staticClass: "name" }, [
                                  _vm._v("时间："),
                                ]),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.printInfo.print_time)),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }